// AUTH-06 Set a new password, from the emailed link (?token=).
import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Button, Form } from "react-aria-components";
import { api, call } from "../../api/client";
import { describeError } from "../../api/errors";
import { Banner } from "../../components/Banner";
import { AuthLayout } from "./AuthLayout";
import { Field, takeTokenFromUrl } from "./fields";

export function ResetPassword() {
  const navigate = useNavigate();
  const [token] = useState(takeTokenFromUrl);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!token) {
    return (
      <AuthLayout title="Set a new password" footer={<Link to="/forgot-password">Send a new link</Link>}>
        <Banner tone="warning">This page needs the link from your email. Links work for one hour and only once.</Banner>
      </AuthLayout>
    );
  }

  async function submit() {
    if (password !== confirm) {
      setError("The passwords don't match.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await call(api.POST("/auth/password/reset", { body: { token: token!, new_password: password } }));
      void navigate({ to: "/sign-in", search: { reset: "1" } });
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout title="Set a new password">
      <p>Use 12 to 128 characters. A long phrase is easier to remember than a short, complicated one.</p>
      {error && <Banner tone="critical">{error}</Banner>}
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          void submit();
        }}
      >
        <Field label="New password" type="password" name="new_password" autoComplete="new-password" minLength={12} maxLength={128} isRequired value={password} onChange={setPassword} autoFocus />
        <Field label="Confirm new password" type="password" name="confirm" autoComplete="new-password" isRequired value={confirm} onChange={setConfirm} />
        <Button type="submit" className="button primary wide" isPending={busy}>
          Set password
        </Button>
      </Form>
    </AuthLayout>
  );
}
